"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.START_TIME_INTERVAL_VALUES = exports.START_TIME_INTERVALS = exports.AUTH_ERROR_TYPES = exports.LINK_TYPE_PARAMS = exports.LINK_TYPES = exports.MEETING_TYPES = exports.DEFAULT_FORM_FIELD_NAMES = exports.FORM_FIELDS_WITH_OPTIONS = exports.FORM_FIELD_TYPES = exports.CAL_INTEGRATIONS = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _immutable = require("immutable");

var CAL_INTEGRATIONS = (0, _keyMirror.default)({
  GOOGLE: null,
  OFFICE365: null,
  EXCHANGE: null,
  UNKNOWN: null
});
exports.CAL_INTEGRATIONS = CAL_INTEGRATIONS;
var FORM_FIELD_TYPES = {
  DATE: 'date',
  NUMBER: 'number',
  TEXT: 'string',
  TEXTAREA: 'textarea',
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
  BOOLEAN_CHECKBOX: 'booleancheckbox',
  ENUMERATION: 'enumeration'
};
exports.FORM_FIELD_TYPES = FORM_FIELD_TYPES;
var FORM_FIELDS_WITH_OPTIONS = [FORM_FIELD_TYPES.RADIO, FORM_FIELD_TYPES.CHECKBOX, FORM_FIELD_TYPES.BOOLEAN_CHECKBOX, FORM_FIELD_TYPES.ENUMERATION];
exports.FORM_FIELDS_WITH_OPTIONS = FORM_FIELDS_WITH_OPTIONS;
var DEFAULT_FORM_FIELD_NAMES = (0, _keyMirror.default)({
  FIRST_NAME: null,
  LAST_NAME: null,
  EMAIL: null
});
exports.DEFAULT_FORM_FIELD_NAMES = DEFAULT_FORM_FIELD_NAMES;
var MEETING_TYPES = {
  PERSONAL: 'personal',
  GROUP: 'group',
  ROUND_ROBIN: 'roundRobin'
};
exports.MEETING_TYPES = MEETING_TYPES;
var LINK_TYPES = (0, _immutable.Map)({
  personal: 'PERSONAL_LINK',
  group: 'GROUP_CALENDAR',
  roundRobin: 'ROUND_ROBIN_CALENDAR'
});
exports.LINK_TYPES = LINK_TYPES;
var LINK_TYPE_PARAMS = (0, _immutable.Map)({
  personal: 'personal',
  team: 'team'
});
exports.LINK_TYPE_PARAMS = LINK_TYPE_PARAMS;
var AUTH_ERROR_TYPES = (0, _keyMirror.default)({
  USER_DECLINED: null,
  SHARED_INBOX_INVALID_DOWNGRADE: null,
  DEFAULT: null,
  SHARED_INBOX: null
});
exports.AUTH_ERROR_TYPES = AUTH_ERROR_TYPES;
var START_TIME_INTERVALS = (0, _keyMirror.default)({
  MEETING_DURATION: null,
  FIVE: null,
  TEN: null,
  FIFTEEN: null,
  TWENTY: null,
  THIRTY: null,
  FORTY_FIVE: null,
  SIXTY: null,
  NINETY: null,
  ONE_HUNDRED_TWENTY: null
});
exports.START_TIME_INTERVALS = START_TIME_INTERVALS;
var START_TIME_INTERVAL_VALUES = {
  MEETING_DURATION: 'MEETING_DURATION',
  FIVE: 5,
  TEN: 10,
  FIFTEEN: 15,
  TWENTY: 20,
  THIRTY: 30,
  FORTY_FIVE: 45,
  SIXTY: 60,
  NINETY: 90,
  ONE_HUNDRED_TWENTY: 120
};
exports.START_TIME_INTERVAL_VALUES = START_TIME_INTERVAL_VALUES;